// Which table backs a chart's patient row.
//
// Visits (the default, byte-identical to before this file existed) live in
// notes-c. Patient-level roster charts (/patients/:uuid) live in
// patients_with_ehrid. Two lookups because callers have different context:
//   - chartTable(patient): components holding the mapped patient object
//     (usePatientDocument stamps `_source: 'roster'` on roster patients).
//   - tableForPatientId(id): the recording engine paths that only carry a bare
//     patient id (AudioRecorder event handlers). usePatientDocument registers
//     each roster id at load time; ids are uuids so collisions can't happen.
import { tableName } from '../../components/env';
import { supabaseSchema } from '../../components/supabaseClient';

const rosterIds = new Set();

export function registerRosterPatientId(id) {
  if (id) rosterIds.add(String(id));
}

export function chartTable(patient) {
  return patient && patient._source === 'roster' ? 'patients_with_ehrid' : tableName;
}

export function tableForPatientId(id) {
  return id != null && rosterIds.has(String(id)) ? 'patients_with_ehrid' : tableName;
}

// Which Postgres schema a chart's patient row lives in. Cross-schema charts
// (a patient pulled from a linked provider) carry `_schema`; everything else
// uses the viewer's active schema — byte-identical to before this existed.
export function chartSchema(patient) {
  return (patient && patient._schema) || supabaseSchema;
}

// Cross-schema providers URL guardrail: is the schema this chart was ASKED to
// open (via `?schema=` / nav-state `_schema`) one the viewer is actually linked
// to? `schemaCsv` is the raw comma-separated `public.users.schema` value. A
// null/blank request means a same-schema open — nothing to gate, always allowed.
// Defense-in-depth on the client only; authoritative enforcement is server-side
// RLS (tenant-table policies are USING(true) by design, so a hand-crafted
// `?schema=` is reachable regardless — this just stops casual URL tampering and
// keeps an honest cross-schema open pinned to a schema the user really has).
export function isSchemaAllowed(requestedSchema, schemaCsv, homeSchema = supabaseSchema) {
  const req = String(requestedSchema || '').trim();
  if (!req) return true;
  const all = String(schemaCsv || homeSchema || '')
    .split(',').map((s) => s.trim()).filter(Boolean);
  return all.includes(req);
}

export function __clearRosterIdsForTests() {
  rosterIds.clear();
}
